"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoodwillPaymentPage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../Types");
var SupportPortalTemplates_1 = require("../../SupportPortalTemplates");
var Confirmation_1 = require("../Confirmation");
var Notification_1 = require("../Notification");
var moment = require("moment");
var commonFunctions_1 = require("../../helpers/commonFunctions");
var GoodwillPaymentPage = /** @class */ (function (_super) {
    __extends(GoodwillPaymentPage, _super);
    function GoodwillPaymentPage(props) {
        var _this = _super.call(this, props) || this;
        _this.supportPortalTemplates = new SupportPortalTemplates_1.SupportPortalTemplates();
        _this.getInputClassName = function (field) {
            if (field === "amount") {
                return _this.state.amountInputValid ? "form-control col-2" : "form-control col-2 is-invalid";
            }
            if (field === "description") {
                return _this.state.descriptionInputValid ? "form-control" : "form-control is-invalid";
            }
            if (field === "reason") {
                return _this.state.reasonInputValid ? "form-control" : "form-control is-invalid";
            }
            return "";
        };
        _this.formValidation = function () {
            if (_this.state.amount && _this.state.description && _this.state.reason) {
                _this.setState({ formValid: true });
            }
            else {
                _this.setState({ formValid: false });
            }
        };
        _this.handleOnAmountChange = function (event) {
            _this.setState({ amount: event.target.value });
            if (event.target.value) {
                _this.setState({ amountInputValid: true });
            }
            else {
                _this.setState({ amountInputValid: false });
            }
            _this.formValidation();
        };
        _this.handlePaymentReasonChange = function (event) {
            _this.setState({ reason: event.target.value });
            if (event.target.value) {
                _this.setState({ reasonInputValid: true });
            }
            else {
                _this.setState({ reasonInputValid: false });
            }
        };
        _this.handleOnDescriptionChange = function (event) {
            _this.setState({ description: event.target.value });
            if (event.target.value) {
                _this.setState({ descriptionInputValid: true });
            }
            else {
                _this.setState({ descriptionInputValid: false });
            }
            _this.formValidation();
        };
        _this.validate = function () {
            if (_this.state.amount) {
                _this.setState({ amountInputValid: true });
            }
            else {
                _this.setState({ amountInputValid: false });
            }
            if (_this.state.description) {
                _this.setState({ descriptionInputValid: true });
            }
            else {
                _this.setState({ descriptionInputValid: false });
            }
            if (_this.state.reason) {
                _this.setState({ reasonInputValid: true });
            }
            else {
                _this.setState({ reasonInputValid: false });
            }
            _this.formValidation();
        };
        _this.handleOnSubmit = function (event) {
            event.preventDefault();
            _this.validate();
            _this.setState({ showConfirmation: true });
        };
        _this.processPayment = function () {
            var _a;
            if (_this.state.formValid && _this.state.amountInputValid && _this.state.reason && _this.state.descriptionInputValid) {
                _this.setState({ loadingRefund: true });
                var payment = { amount: _this.state.amount, reason: _this.state.reason, description: _this.state.description };
                _this.supportPortalService.doGoodwillPayment(_this.props.params.number, payment).subscribe(function (e) {
                    if (e instanceof Error) {
                        _this.setState({ loadingRefund: false });
                    }
                    else {
                        _this.props.navigate("/customers/".concat(_this.props.params.id, "/payments?policy=").concat(_this.props.params.number));
                        window.location.reload();
                    }
                });
                _this.supportPortalService.logAgentActivity(_this.props.params.id, { "action": "Goodwill payment: ".concat(payment.amount), "customer": _this.props.params.number, "id": (_a = _this.state.agentActivityId) === null || _a === void 0 ? void 0 : _a.toString() }).subscribe();
            }
        };
        _this.state = {
            amount: 0,
            reason: "",
            description: "",
            amountInputValid: true,
            reasonInputValid: true,
            descriptionInputValid: true,
            formValid: false,
            loadingRefund: false,
            showConfirmation: false,
            showWarning: false,
            showPaymentNotPossibleNotification: false,
            notificationChosen: false,
            paymentNotPossible: false,
            loadingPayments: true,
            goodwillPaymentCount: -1
        };
        return _this;
    }
    GoodwillPaymentPage.prototype.componentDidMount = function () {
        var _this = this;
        this.supportPortalService.getPayments(this.props.params.id).subscribe(function (payments) {
            _this.setState({ payments: payments, loadingPayments: false });
        });
        this.supportPortalService.logAgentActivity(this.props.params.id, { "action": "No Action", "customer": this.props.params.number }).subscribe(function (agentActivity) {
            _this.setState({ agentActivityId: agentActivity.id });
        });
    };
    GoodwillPaymentPage.prototype.render = function () {
        var _this = this;
        if (this.state.loadingPayments) {
            return (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: true });
        }
        else if (this.supportPortalTemplates.userHasRole(["Administrator", "CSR_Lead", "CSR"])) {
            if (this.state.goodwillPaymentCount < 0) {
                this.setState({ goodwillPaymentCount: this.countGoodwillPayments() });
            }
            if (!this.state.notificationChosen && this.state.goodwillPaymentCount > 1) {
                this.setState({ showPaymentNotPossibleNotification: true, paymentNotPossible: true, notificationChosen: true });
            }
            else if (!this.state.notificationChosen && this.state.goodwillPaymentCount === 1) {
                this.setState({ showWarning: true, notificationChosen: true });
            }
            else if (!this.state.notificationChosen && this.state.goodwillPaymentCount === 0) {
                this.setState({ notificationChosen: true });
            }
            return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)(components_1.Overlay, { show: this.state.loadingRefund }), this.supportPortalTemplates.renderBackLink("Customer details", true, "/customers/".concat(this.props.params.id)), (0, jsx_runtime_1.jsx)(Notification_1.default, { show: this.state.showWarning, hide: function () { return _this.setState({ showWarning: false }); }, title: "Warning!", message: "This user already received one goodwill payment.\nPlease check if this payment has been issued previously." }), (0, jsx_runtime_1.jsx)(Notification_1.default, { show: this.state.showPaymentNotPossibleNotification, hide: function () { return _this.setState({ showPaymentNotPossibleNotification: false }); }, title: "Warning!", message: "This user already received two goodwill payments\nover the course of one year.\nNo further payments are possible." }), (0, jsx_runtime_1.jsxs)("form", { className: "row panel-border px-3", onSubmit: this.handleOnSubmit, children: [(0, jsx_runtime_1.jsxs)("div", { className: "form-group col-12", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "amount", children: "Select refund amount \u00A3" }), (0, jsx_runtime_1.jsx)("input", { type: "number", name: "amount", step: "0.01", className: this.getInputClassName("amount"), onChange: this.handleOnAmountChange, min: "0.01", max: "200.00", pattern: "\\d+(\\.\\d{1,2})?" }), this.state.amountInputValid ? "" : (0, jsx_runtime_1.jsx)("div", { className: "invalid-feedback d-block", children: "This is a mandatory field!" }), (0, jsx_runtime_1.jsx)("label", { htmlFor: "paymentReason", className: "mt-3", children: "Select reason" }), (0, jsx_runtime_1.jsxs)("select", { id: "paymentReason", name: "paymentReason", className: this.getInputClassName("reason"), value: this.state.reason, onChange: this.handlePaymentReasonChange, children: [(0, jsx_runtime_1.jsx)("option", { value: "", children: "Please choose..." }), (0, jsx_runtime_1.jsx)("option", { value: "Goodwill Payment", children: "Complaints - Goodwill Payment" }), (0, jsx_runtime_1.jsx)("option", { value: "Redress Payment", children: "Complaints - Redress Payment" }), (0, jsx_runtime_1.jsx)("option", { value: "Distress & Inconvenience Payment", children: "Complaints - Distress & Inconvenience Payment" })] }), this.state.reasonInputValid ? "" : (0, jsx_runtime_1.jsx)("div", { className: "invalid-feedback d-block", children: "This is a mandatory field!" }), (0, jsx_runtime_1.jsx)("label", { htmlFor: "description", className: "mt-3", children: "Type refund description" }), (0, jsx_runtime_1.jsx)("input", { type: "text", name: "description", className: this.getInputClassName("description"), onChange: this.handleOnDescriptionChange }), this.state.descriptionInputValid ? "" : (0, jsx_runtime_1.jsx)("div", { className: "invalid-feedback d-block", children: "This is a mandatory field!" }), (0, jsx_runtime_1.jsx)(Confirmation_1.default, { show: this.state.showConfirmation, hide: function () { return _this.setState({ showConfirmation: false }); }, confirm: this.processPayment, title: "Warning!", message: "Are you sure you want to issue a goodwill payment of ".concat((0, commonFunctions_1.getAmountToDisplay)(this.state.amount), "?") })] }), this.state.paymentNotPossible ? "" :
                                (0, jsx_runtime_1.jsx)("div", { className: "form-group col-12 clearfix", children: (0, jsx_runtime_1.jsx)("button", { type: "submit", className: "btn btn-primary mr-0 float-right", children: "Submit" }) })] })] }));
        }
        else {
            return this.supportPortalTemplates.renderErrorPage();
        }
    };
    GoodwillPaymentPage.prototype.countGoodwillPayments = function () {
        var count = 0;
        if (this.state.payments && this.state.payments.results && this.state.payments.count > 0) {
            for (var _i = 0, _a = this.state.payments.results; _i < _a.length; _i++) {
                var payment = _a[_i];
                if (payment.statusCode === "COMPLETED" && moment(payment.date).isAfter(moment().subtract(1, "year"))
                    && payment.description === "Goodwill/Other") {
                    count++;
                }
            }
        }
        return count;
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], GoodwillPaymentPage.prototype, "supportPortalService", void 0);
    GoodwillPaymentPage = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], GoodwillPaymentPage);
    return GoodwillPaymentPage;
}(React.Component));
exports.GoodwillPaymentPage = GoodwillPaymentPage;
exports.default = (0, components_1.withRouter)(GoodwillPaymentPage);
//# sourceMappingURL=GoodwillPaymentPage.js.map